import { render, staticRenderFns } from "./main-animation.vue?vue&type=template&id=247d083c"
import script from "./main-animation.vue?vue&type=script&lang=js"
export * from "./main-animation.vue?vue&type=script&lang=js"
import style0 from "./main-animation.vue?vue&type=style&index=0&id=247d083c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports